import Cookies from "js-cookie"
Window.Cookies = Cookies

import initAxios from './bootstrap'
import initSmoothScroll from './core-polyfill'
import initBodyScrollStatus from './body-scroll-status'
import initAccordion from './accordion'
import initSplide from './splide.js'
import initMobileNavigation from './mobile-navigation.js'
import initSitemap from '../sections/sitemap.js'
import initLazyframe from './lazyframe'
import initScrollTo from './scroll-to'
import initGallery from './gallery.js'
import './fontawesome.js'
import { Livewire } from '../../../vendor/livewire/livewire/dist/livewire.esm';

Livewire.start()

let optionalInits = []

function requireOptionalFiles() {
  const modules = import.meta.glob('./optionals/**/*.js', { eager: true })

  optionalInits = Object.values(modules)
    .filter((mod) => typeof mod.default === 'function')
    .map((mod) => mod.default)

  optionalInits.forEach((fn) => fn())
}

requireOptionalFiles()

document.addEventListener("DOMContentLoaded", () => {
  // Core utils
  initScrollTo()
  initLazyframe()
  initGallery()
  initSitemap()
  initMobileNavigation()
  initSplide()
  initAccordion()
  initBodyScrollStatus()
  initSmoothScroll()
  initAxios()

  // Re-run dynamic optionals
  optionalInits.forEach((fn) => fn())
})
